"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BiosphereSupport = void 0;
var Tags_1 = require("../Tags");
var PreludeCard_1 = require("./PreludeCard");
var Resources_1 = require("../../Resources");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var BiosphereSupport = (function (_super) {
    __extends(BiosphereSupport, _super);
    function BiosphereSupport() {
        return _super.call(this, {
            name: CardName_1.CardName.BIOSPHERE_SUPPORT,
            tags: [Tags_1.Tags.PLANT],
            metadata: {
                cardNumber: 'P05',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) {
                        pb.minus().megacredits(1).br;
                        pb.plants(2);
                    });
                }),
                description: 'Increase your plant production 2 steps. Decrease your M€ production 1 step.',
            },
        }) || this;
    }
    BiosphereSupport.prototype.canPlay = function (player) {
        return player.getProduction(Resources_1.Resources.MEGACREDITS) >= -4;
    };
    BiosphereSupport.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.MEGACREDITS, -1);
        player.addProduction(Resources_1.Resources.PLANTS, 2);
        return undefined;
    };
    return BiosphereSupport;
}(PreludeCard_1.PreludeCard));
exports.BiosphereSupport = BiosphereSupport;
//# sourceMappingURL=BiosphereSupport.js.map